var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("activity_report")}},[(_vm.items.length)?_c('ja-data-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"pagination":_vm.pagination,"on-change-page":_vm.handleChangePage,"on-row-click":_vm.handleClickRow}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }